import React, { useEffect, useState } from 'react'
import { Button, message, Modal, Space, Tag, Tooltip } from 'antd'
import {
  CloseOutlined,
  SaveOutlined,
  TeamOutlined,
  UserOutlined,
  BankOutlined,
} from '@ant-design/icons'
import { SelectList, SelectTitle } from './InternalMessageCreateModalStyled'
import { inject, observer } from 'mobx-react'
import { blue, yellowPrimary } from '../../color'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import { AvatarHasName } from '../../components/Common/Avatar'
import SelectGroupMemberPopup from '../../components/SelectGroupMemberPopup'
import { ASSIGNEE_TYPE } from '../../constants'

const styleFooter = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginTop: 30,
}

const InternalMessageEditReceiversModal = props => {
  const {
    isVisible,
    handleCancel,
    internalMessageStore,
    selectPeopleStore,
    loadingAnimationStore,
    code,
    receivers,
    isReceive = false,
  } = props

  const {
    selectUserData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
  } = selectPeopleStore

  const [userDataList, setUserDataList] = useState([])

  useEffect(() => {
    if (isVisible && receivers) {
      // Pre-populate selectPeopleStore with existing receivers
      selectPeopleStore.clearSelectUserData()
      selectPeopleStore.clearSelectGroupData()

      const formattedReceivers = receivers.map(item => ({
        id: item.username || item.code || item.id,
        user_name: item.username || item.code || item.id,
        full_name: item.fullname || item.full_name,
        assignee_type: ASSIGNEE_TYPE.USER,
      }))

      selectPeopleStore.setSelectUserData({
        ...selectUserData,
        [ASSIGNEE_TYPE.HANDLER]: formattedReceivers,
      })
    }
  }, [isVisible, receivers])

  useEffect(() => {
    setUserDataList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
  }, [selectUserData, selectGroupData])

  const handleCancelForm = () => {
    handleCancel()
    selectPeopleStore.clearSelectUserData()
    selectPeopleStore.clearSelectGroupData()
  }

  const handleSave = async () => {
    const selectIdList = selectUserData[ASSIGNEE_TYPE.HANDLER].map(
      user => user.id
    )
    const selectIdUserGroupList = selectGroupData[ASSIGNEE_TYPE.HANDLER]
      .map(group => group.users.map(user => user.user.user_name))
      .flat()

    const selectIdHandlerList = [...selectIdList, ...selectIdUserGroupList]
    const receiverValue = [...new Set(selectIdHandlerList)] // Filter ID trùng

    if (receiverValue.length === 0) {
      return message.warning(
        'Chưa chọn người nhận hoặc Nhóm được chọn không có thành viên'
      )
    }

    loadingAnimationStore.showSpinner(true)
    try {
      await internalMessageStore.updateReceivers(code, receiverValue)

      // Refresh the same detail endpoint that opened this modal.
      if (isReceive) {
        await internalMessageStore.getReceiveMessageById(code)
      } else {
        await internalMessageStore.getSendMessageById(code)
      }

      handleCancelForm()
      message.success('Chỉnh sửa người nhận thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  return (
    <Modal
      title="Chỉnh sửa người nhận"
      footer={null}
      visible={isVisible}
      width={560}
      onCancel={handleCancelForm}
      maskClosable={false}>
      <SelectTitle>
        <span>
          <span
            style={{
              color: '#ff4d4f',
              fontFamily: 'SimSun, sans-serif',
              marginRight: '-4px',
            }}>
            *{' '}
          </span>
          <span style={{ marginRight: '10px' }}>Người nhận:</span>
        </span>
        <Space>
          <Tooltip title="Chọn người dùng" color={blue}>
            <Button
              icon={<UserOutlined style={{ color: blue }} />}
              onClick={() =>
                handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
              }
            />
          </Tooltip>
          <Tooltip title="Chọn nhóm" color={'#ffc069'}>
            <Button
              icon={<TeamOutlined />}
              style={{ color: yellowPrimary }}
              onClick={() => handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)}
            />
          </Tooltip>
        </Space>
      </SelectTitle>
      <SelectList
        style={{
          minHeight: '58px',
          border: '1px solid #d9d9d9',
          borderRadius: '4px',
          padding: '4px 6px',
          gap: '6px',
        }}>
        {userDataList.map(el => (
          <Tag
            className={'tag-selected'}
            color={'blue'}
            key={el.id}
            closable
            style={{
              padding: '0 6px 0 3px',
              fontSize: '12px',
              lineHeight: '18px',
            }}
            onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
            <AvatarHasName
              imgId={el.image_id}
              size={18}
              name={el.full_name}
              icon={
                (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                  <BankOutlined />
                )) ||
                (el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />)
              }
            />
          </Tag>
        ))}
        {userDataList.length === 0 && (
          <span style={{ color: '#aaa', fontStyle: 'italic' }}>
            Chưa có người nhận nào
          </span>
        )}
      </SelectList>

      <div style={styleFooter}>
        <Space>
          <Button icon={<CloseOutlined />} danger onClick={handleCancelForm}>
            Đóng
          </Button>
          <Button icon={<SaveOutlined />} type={'primary'} onClick={handleSave}>
            Cập nhật
          </Button>
        </Space>
      </div>

      <SelectPeoplePopup
        disableSelectDepartment={true}
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupMemberPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </Modal>
  )
}

export default inject(
  'loadingAnimationStore',
  'internalMessageStore',
  'selectPeopleStore'
)(observer(InternalMessageEditReceiversModal))
